import { render } from "./CatalogSkeleton.vue?vue&type=template&id=10b40c54"
import script from "./CatalogSkeleton.vue?vue&type=script&lang=js"
export * from "./CatalogSkeleton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tin/Documents/asket/stone-xxi.ru-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__